module.exports = "/images/vendor/vue-paycard/src/16.jpg?57856aa8f7fe7493d368f163b56f3c00";